var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _path12, _path13, _path14, _path15, _path16, _path17;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgEmpty(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 283,
    height: 212,
    viewBox: "0 0 283 212",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M236.76 45.5796V56.7225",
    stroke: "#F3F3F3",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M231.197 51.1392H242.322",
    stroke: "#F3F3F3",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M8.67578 2.58545V13.7025",
    stroke: "#F3F3F3",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M3.08789 8.14355H14.2385",
    stroke: "#F3F3F3",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M205.896 11.8413H78.2977C74.2113 11.8413 70.8984 15.1518 70.8984 19.2355V202.124C70.8984 206.208 74.2113 209.518 78.2977 209.518H205.896C209.983 209.518 213.295 206.208 213.295 202.124V19.2355C213.295 15.1518 209.983 11.8413 205.896 11.8413Z",
    stroke: "#F3F3F3",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M172.753 153.829H111.411C109.111 153.829 107.246 155.693 107.246 157.992V158.017C107.246 160.316 109.111 162.18 111.411 162.18H172.753C175.053 162.18 176.918 160.316 176.918 158.017V157.992C176.918 155.693 175.053 153.829 172.753 153.829Z",
    fill: "white"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M170.555 187.957H111.697C110.997 187.957 110.43 188.524 110.43 189.223V189.611C110.43 190.311 110.997 190.878 111.697 190.878H170.555C171.256 190.878 171.823 190.311 171.823 189.611V189.223C171.823 188.524 171.256 187.957 170.555 187.957Z",
    fill: "white"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M185.557 174.28H98.8613C97.9328 174.28 97.1797 175.033 97.1797 175.961C97.1797 176.889 97.9328 177.641 98.8613 177.641H185.557C186.486 177.641 187.239 176.889 187.239 175.961C187.239 175.033 186.486 174.28 185.557 174.28Z",
    fill: "white"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M201.42 17.8652H82.7729C79.8295 17.8652 77.4434 20.2497 77.4434 23.1911V126.011C77.4434 128.953 79.8295 131.337 82.7729 131.337H201.42C204.363 131.337 206.749 128.953 206.749 126.011V23.1911C206.749 20.2497 204.363 17.8652 201.42 17.8652Z",
    stroke: "#F3F3F3",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M157.927 99.4593C158.772 99.4391 159.591 99.1624 160.275 98.6663C160.959 98.1699 161.476 97.4773 161.757 96.6805C162.038 95.8837 162.069 95.0202 161.847 94.205C161.625 93.3898 161.16 92.6615 160.514 92.1168C155.118 87.6501 148.314 85.234 141.308 85.2956C134.301 85.3569 127.541 87.8921 122.224 92.4529C121.583 92.9958 121.123 93.7205 120.904 94.531C120.686 95.3415 120.719 96.1994 121 96.9905C121.281 97.7816 121.795 98.4688 122.476 98.9605C123.157 99.4523 123.971 99.7253 124.811 99.7436L157.927 99.4593Z",
    fill: "white",
    stroke: "#F3F3F3",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M179.064 73.5797L163.98 64.8929L179.064 56.1802",
    stroke: "#F3F3F3",
    strokeWidth: 0.71,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M103.885 73.5797L118.968 64.8929L103.885 56.1802",
    stroke: "#F3F3F3",
    strokeWidth: 0.71,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "M21.1719 128.726V139.869",
    stroke: "#F3F3F3",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    d: "M15.6094 134.284H26.7599",
    stroke: "#F3F3F3",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    d: "M275.127 178.39V189.533",
    stroke: "#F3F3F3",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    d: "M269.564 183.949H280.715",
    stroke: "#F3F3F3",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    d: "M232.049 136.61C233.45 136.61 234.584 135.476 234.584 134.077C234.584 132.677 233.45 131.543 232.049 131.543C230.649 131.543 229.514 132.677 229.514 134.077C229.514 135.476 230.649 136.61 232.049 136.61Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEmpty);
export default __webpack_public_path__ + "static/media/empty.2a0d06f472f1920347154d2df29e2e33.svg";
export { ForwardRef as ReactComponent };